"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentEmbeddingSpecificationSchema = exports.DocumentChunkingSpecificationSchema = void 0;
const zod_1 = require("zod");
const presets_1 = require("./presets");
exports.DocumentChunkingSpecificationSchema = zod_1.z.object({
    fileId: zod_1.z.string(),
    ocrPresetName: presets_1.OcrPresetNameSchema,
    chunkingPresetName: presets_1.ChunkingPresetNameSchema,
});
exports.DocumentEmbeddingSpecificationSchema = exports.DocumentChunkingSpecificationSchema.extend({
    embeddingPresetName: presets_1.EmbeddingPresetNameSchema,
});
//# sourceMappingURL=document-specifications.js.map